<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <slider
                :value="sliderIndex"
                :values="themeObjectValues"
                show-decimal
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';

export default {
    name: 'letter-spacing',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Letter Spacing',
            sliderIndex: 2,
            tailwindDefinitionProp: 'letterSpacing',
        };
    },
};
</script>
